import type { SVGProps } from 'react'

interface Props extends SVGProps<SVGSVGElement> {
  color?: string
}

export default function QuickFilterBrandDecathlonIcon({
  color = '#101010',
}: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
    >
      <path
        d="M10.9498 0.500001C6.09762 0.500001 0.0620117 5.7574 0.0620117 10.1147C0.0620117 12.365 1.71261 13.5 3.89266 13.5C5.49343 13.5 7.43056 12.8869 9.29916 11.7062V3.01129C8.80087 3.90492 6.45888 7.50552 4.57782 9.42323C3.6186 10.4017 2.85869 10.8256 2.20468 10.8256C1.46969 10.8256 1.12089 10.3038 1.12089 9.5276C1.12089 6.00527 6.78277 1.42624 10.5325 1.42624C12.0772 1.42624 13.0738 2.14375 13.0738 3.53964C13.0738 4.81811 12.2453 6.42273 10.8314 7.90341V10.5973C13.298 8.55569 14.7742 5.95309 14.7742 3.85273C14.7742 1.64149 13.1298 0.500001 10.9498 0.500001Z"
        fill={color}
      />
    </svg>
  )
}
